import dayjs from "dayjs";
import AppContext from "./AppContext";
import { fldInfsProps } from "./ui/GridTable";

export interface codeProps {
    code: string
    name?: string
    backgroundUrl?: string
}
export type Order = 'asc' | 'desc';
export type ynType = "Y" | "N";
export type dataTypeCdType = "1001" | "1002" | "1003" | "1004";
export type schemaCdType = "TABLE" | "VIEW";

// 테이블 정보 Props
export interface TableInfoProps {
    engDataNm: string
    kornDataNm: string
    schemaCd: schemaCdType
    dataSeCd: string
    dataExpln: string
    ldgrYn: ynType
    editYn: ynType
    pstnPrintYn: ynType
    dataTypeCd: dataTypeCdType
    btchEditYn: ynType
    ldgrTypeCd: string
    lnkgTblNm: string
    imgTblNm: string
    updtTypeCd: string
    updtPrdCd: string
    mdfcnDt: string
    dataSeq: number
    tabNm: string
    colLen: number
    lyrPkColNm: string
    dmsCd: string
    atrbEditYn: ynType
    sptlEditYn: ynType
    inqYn: ynType
    expYn: ynType
    fieldNameList: string[]
    tabHeaderList: string[]
    fieldNameListCamelCase: string[]
    linkedTableList: {linkedNm: string, pkNm: string}[][]
    linkedTableFieldInfo: Record<string, any>[]
}
// 필드 정보 Props
export interface FieldInfoProps {
    id: number
    dataName: string
    fieldName: string
    fieldNameCamelCase: string
    fieldNo: number
    fieldAlias: string
    fieldAbbr: string
    tabHeader: string
    tabOrder: number
    tabFieldSeq: number
    linkedTableFld: string
    reflectColumns: string
    isAdminInfo: number
    isDomain: number
    domainTypeCodes: string
    defaultCodeValue: string
    isViewBook: number
    isViewGrid: number
    userSrchRsltExprsYn: 'Y' | 'N'
    userBscSrchCndYn: 'Y' | 'N'
    srchRsltExprsYn: 'Y' | 'N'
    bscSrchCndYn: 'Y' | 'N'
    editYn: 'Y' | 'N'
    isBatchEdit: number
    isEditAutoFld: number
    unit: string
    controlTypeCode: "1001" | "1002" | "1003" | "1004" | "1005"
    isFillBookCol: number
    isPk: number
    isNotNull: number
    fieldType: string
    fieldLength: number
    fieldScale: number
    etcFld: string
    isViewGridTab: number
    insAutoValDate: number
    insAutoValClient: number
    updAutoValDate: number
    updAutoValClient: number
    seqColYn: 'Y' | 'N'
}
// 커스텀 필드 정보 Props
export interface CstmFieldInfoProps {
    id: number
    dataName: string
    fieldName: string
    tgtFieldName: string
    joinDataName: string
    joinFieldName: string
    functionName: string
    fieldAbbr: string
    tabHeader: string
    tabOrder: number
    tabFieldSeq: number
    isViewBook: number
    isViewGrid: number
    isDefaultSearch: number
    isFillBookCol: number
    isViewGridTab: number
    controlTypeCode?: "1001" | "1002" | "1003" | "1004" | "1005"
    fieldType?: string
    linkedTableFld?: string
    fieldLength?: number
    fieldScale?: number
    domainTypeCodes?: string
    unit?: string
    isNotNull?: number
    fieldNameCamelCase?: string
}

export enum EquipJobCode {
    EQBK = 'JOB001',  // 설비대장관리
    POCK = 'JOB002',  // 관로이상지점점검
    PNLCK = 'JOB003', // 판넬점검
    TPCK = 'JOB004',  // 테스트포인트점검
    OTCCK = 'JOB005', // 타공사점검
    MNHL = 'JOB006',  // 맨홀점검
    HNDHL = 'JOB007', // 핸드홀점검
    RPAR = 'JOB008',  // 보수대상
    RSLT = 'JOB009',  // 보수결과
    PUC = 'JOB010',   // 공동구/노출배관
    RDHCK = 'JOB011', // 지열지점점검
    IMPCK = 'JOB012', // 중점관리구간점검
    WLPIPE = 'JOB014' // 누수감시점검
}
export interface fileProps {
    fileSn: number
    fileNm: string
    fileExt: string
    fileSize: number
}
const Util = {
    /**
     * @description Null & undefined 확인
     * @param {*} str 확인할 값
     * @returns {boolean}
     */
    isNull: (str: any): boolean => {
        return str === null || str === undefined;
    },
    /**
     * @description Null & undefined & 공백 확인
     * @param {*} 확인할 값
     * @returns {boolean}
     */
    isEmpty: (str: any): boolean => {
        let returnCheck = Util.isNull(str);
        if (!returnCheck) {
            if (String(str).trim().length === 0) returnCheck = true;
        }
        return returnCheck;
    },
    isNotEmpty: function (str: any) {
        return !this.isEmpty(str);
    },
    getLength: (str: string) => {
        return str.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
    },
    nvl: function(str: any, changeStr: any) {
        if (this.isEmpty(str)) {
            str = changeStr;
        }
        return str;
    },
    getDayNm: function(dayFlag: any) {
        if (this.isEmpty(dayFlag)) {
            alert("날짜 flag 정보가 없습니다.");
            return;
        }
        if (dayFlag < 1 || dayFlag > 7) {
            alert("유효한 날짜 flag 정보가 아닙니다.[1(월) ~ 7(금) 사이로 바인딩 가능]");
            return;
        }
        if (dayFlag === 1) {
            return "월";
        } else if (dayFlag === 2) {
            return "화";
        } else if (dayFlag === 3) {
            return "수";
        } else if (dayFlag === 4) {
            return "목";
        } else if (dayFlag === 5) {
            return "금";
        } else if (dayFlag === 6) {
            return "토";
        } else if (dayFlag === 7) {
            return "일";
        }
    },
    /**
     * @description 숫자를 문자로 변환
     * @param {number} val 변경할 숫자
     * @returns {string}
     */
    convertNumToString: (val: any): string => {
        let returnVal = '';
        if(typeof val === 'string') {
            returnVal = val;
        } else if(typeof val === 'number' && val.toString() !== 'NaN' && val !== Infinity && val !== -Infinity) {
            returnVal = val.toString();
        }
        return returnVal;
    },
    comma: (str: string) => {
        if (Util.isEmpty(str)) {
            return "";
        } else {
            str = Util.uncomma(str);
            // return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            str = String(str);
            const ss = str.split('.');
            ss[0] = ss[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
            return ss.join('.');
        }
    },
    /**
     * @description 콤마 지우기
     * @param {string} str 문자열
     * @returns {string}
     */
    uncomma: function(str: string): string {
        if (this.isNull(str)) return '';
        str = String(str);
        return str.replace(/,/g, '');
    },
    /**
     * @description 왼쪽 채우기
     * @param {string} str 문자열
     * @param {number} nLength 자리수
     * @param {string} padStr 채울 문자
     * @returns {string}
     */
    lpad: function(str: string, nLength: number, padStr: string): string {
        if (this.isNull(str)) {
            return '';
        }
        str = this.convertNumToString(str);
        while(str.length < nLength) {
            str = padStr + str;
        }
        return str;
    },
    /**
     * 특정날짜 가져오기
     * @param {string} str 구분자
     * @param {string} calFg 계산 대상 년, 월, 일 구분
     * @param {string} calVal 계산할 수치 ( + / - )
     * @param {string} format 출력 형식(YYYY(YYYY), MM(YYYY-MM), DD(YYYY-MM-DD), HH(YYYY-MM-DD HH), MI(YYYY-MM-DD HH24:MM), SS(YYYY-MM-DD HH24:MM:SS))
     * @param {string} baseYmd(YYYY-MM-DD) 계산대상 일자, 값 없을 시 디폴트로 현재일자 세팅
     */
    getSpecificDate: function(str: string, calFg: "year" | "month" | "day" | "hour" | "min" | "sec", calVal: number, format: string, baseYmd: string) {
        let now = new Date();

        if (this.isEmpty(baseYmd)) {
            now = new Date();
        } else {
            now = new Date(baseYmd);
        }

        let setDt = new Date();

        calVal = calVal === undefined ? 0 : calVal; // 값 없을 시 계산안함

        if (calVal !== undefined) {
            // 구분에 따른 시간 계산 : 년, 월, 일, 시간, 분, 초
            if (calFg === "year") {
                setDt = new Date(now.setFullYear(now.getFullYear() + calVal));
            } else if (calFg === "month") {
                setDt = new Date(now.setMonth(now.getMonth() + calVal));
            } else if (calFg === "day") {
                setDt = new Date(now.setDate(now.getDate() + calVal));
            } else if (calFg === "hour") {
                setDt = new Date(now.setHours(now.getHours() + calVal));
            } else if (calFg === "min") {
                setDt = new Date(now.setMinutes(now.getMinutes() + calVal));
            } else if (calFg === "sec") {
                setDt = new Date(now.setSeconds(now.getSeconds() + calVal));
            } else {
                alert('계산할 구분 대상이 없습니다.');
                return;
            }
        } else {
            alert('계산할 변수 수치가 없습니다.');
            return;
        }

        const year = setDt.getFullYear();
        const month = this.lpad((setDt.getMonth() + 1).toString(), 2, "0");
        const date = this.lpad(setDt.getDate().toString(), 2, "0");
        const hour = this.lpad(setDt.getHours().toString(), 2, "0");
        const min  = this.lpad(setDt.getMinutes().toString(), 2, "0");
        const sec  = this.lpad(setDt.getSeconds().toString(), 2, "0");

        str = (str === null ? '' : str);

        let nowStr: string = year + str + month + str + date;

        if (format === "YYYY") {
            nowStr = year.toString();
        } else if (format === "MM") {
            nowStr = year + str + month;
        } else if (format === "DD") {
            nowStr = year + str + month + str + date;
        } else if (format === "YYMMDD") {
            nowStr = year + str + month + str + date;
            nowStr = nowStr.substring(2, 8);
        } else if (format === "HH") {
            nowStr = year + str + month + str + date + " " + hour;
        } else if (format === "MI") {
            nowStr = year + str + month + str + date + " " + hour + ":" + min;
        } else if (format === "SS") {
            if (this.isEmpty(str)) {
                nowStr = year + month + date + hour + min + sec;
            } else {
                nowStr = year + str + month + str + date + "T" + hour + ":" + min + ":" + sec;
            }
        } else {
            nowStr = year + str + month + str + date;
        }
        return nowStr.toString();
    },
    cvtSecToTime: (sec: number) => {
        // 분 : 1 * 60
        // 시간 : 분 * 60
        let retText = "";
        if (sec / (60 * 60) >= 1) {
            const hour = Math.floor(sec / (60 * 60));
            retText = Util.lpad(hour.toString(), 2, "0") + ":"
        }
        if (sec % (60 * 60) / 60 >= 1) {
            const min = Math.floor(sec % (60 * 60) / 60);
            retText = retText + Util.lpad(min.toString(), 2, "0") + ":"
        }
        retText = retText + Util.lpad(Math.floor(sec % (60 * 60) % 60).toString(), 2, "0");
        return retText;
    },
    getMonthName: (month: number) => {
        let retData: string = "";
        if (month === 1) retData = "JANUARY";
        else if (month === 2) retData = "FEBRUARY";
        else if (month === 3) retData = "MARCH";
        else if (month === 4) retData = "APRIL";
        else if (month === 5) retData = "MAY";
        else if (month === 6) retData = "JUNE";
        else if (month === 7) retData = "JULY";
        else if (month === 8) retData = "AUGUST";
        else if (month === 9) retData = "SEPTEMBER";
        else if (month === 10) retData = "OCTOBER";
        else if (month === 11) retData = "NOVEMBER";
        else if (month === 12) retData = "DECEMBER";
        return retData;
    },
    dateToString: function (source: any, format: string) {
        const date = new Date(source);
        if (!isFinite(Number(date))) {
            return "";
        }
        let month = "";
        let day = "";
        const year = date.getFullYear();
        if (date.getMonth() + 1 >= 10) {
            month = (date.getMonth() + 1).toString();
        } else {
            month = this.lpad((date.getMonth() + 1).toString(), 2, "0");
        }
        if (date.getDate() >= 10) {
            day = date.getDate().toString();
        } else {
            day = this.lpad(date.getDate().toString(), 2, "0");
        }
        if ((year + month + day).length !== 8) { // 날짜가 완전히 입력되지 않으면 빈 값 리턴
            return "";
        }
        if (format === "YYYY-MM-DD") {
            return [year, month, day].join('-');
        } else if (format === "YYYY.MM.DD") {
            return [year, month, day].join('.');
        } else {
            return year + month + day;
        }
    },
    cvtDateStrForm: (dateStr: string, separetor: string, type?: string) => {
        if (Util.isEmpty(dateStr)) {
            return "";
        }

        switch (type) {
            case 'YYYYMMDDHHMM':
                return dateStr.substring(0, 4) + separetor + dateStr.substring(4, 6) + separetor + dateStr.substring(6, 8) + " " + dateStr.substring(8, 10) + ":" + dateStr.substring(10, 12);
            case 'YYYYMMDD':
                return dateStr.substring(0, 4) + separetor + dateStr.substring(4, 6) + separetor + dateStr.substring(6, 8);
            case 'HH24MM':
                return dateStr.substring(0, 2) + separetor + dateStr.substring(2, 4);
            default:
                return dateStr.substring(0, 4) + separetor + dateStr.substring(4, 6) + separetor + dateStr.substring(6, 8);
        }
    },
    compareStr: (data1: string | undefined, data2: string | undefined, mode: "min" | "max") => {
        if (data1 === undefined) {
            data1 = "";
        }
        if (data2 === undefined) {
            data2 = "";
        }
        if (Util.isEmpty(data1) && Util.isNotEmpty(data2)) {
            return data2;
        } else if (Util.isNotEmpty(data1) && Util.isEmpty(data2)) {
            return data1;
        } else if (Util.isEmpty(data1) && Util.isEmpty(data2)) {
            return "";
        } else if (Util.isNotEmpty(data1) && Util.isNotEmpty(data2)) {
            if (data1 > data2) {
                if (mode === "min") {
                    return data2;
                } else if (mode === "max") {
                    return data1;
                }
            } else if (data1 < data2) {
                if (mode === "min") {
                    return data1;
                } else if (mode === "max") {
                    return data2;
                }
            } else {
                return data1;
            }
        } else {
            return "";
        }
    },
    setPhoneNum: (inputValue?: string) => {
        if (Util.isEmpty(inputValue) || inputValue === undefined) {
            return "";
        }
        inputValue = inputValue.replace(/-/g, "");;
        if (isNaN(Number((inputValue)))) {
            return inputValue.slice(0, -1);
        }
        return inputValue.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    },
    cvtPhoneStrForm: (phoneStr: string, separetor: string) => {
        if (Util.isEmpty(phoneStr)) {
            return "";
        } else {
            return phoneStr.substring(0, 3) + separetor + phoneStr.substring(3, 7) + separetor + phoneStr.substring(7, 11);
        }
    },
    getValToCode: (catCode: string, code: string) => {
        let retVal = "";
        for (const codeInfo of AppContext.codeList) {
            if (codeInfo["catCode"] === catCode && codeInfo["code"] === code) {
                retVal = codeInfo["name"];
                break;
            }
        }
        return retVal;
    },
    getCodeArray: (catCode: string) => {
        const codeArr: any[] = [];
        AppContext.codeList.forEach((item: any) => {
            if (item.catCode === catCode) {
                codeArr.push(item);
            }
        });
        return codeArr;
    },

    /**
     * 운영비 관 코드
     * @param sbjctLvCd     관(01), 항(02), 목(03)
     * @param sbjctSeCd     수입(01),지출(02)
     * @param ognzCd        조직코드(ognzCd) - 마지막 3자리 확인: '000' → 본부(01) / != '000' → 지부(02)
     * @param bgtSbjctOgnzSeCd  공통(10), 본부(01), 지부(02)
     * @returns
     */
    getBgt1CodeArray: (sbjctSeCd: string, ognzCd: string) => {
        const codeArr: any[] = [];
        const ognzType: string = ognzCd.slice(-3) === "000" ? "01" : "02";
        AppContext.bgtSbjctList.forEach((item: any) => {
            if (item.sbjctLvCd === "01" && item.sbjctSeCd === sbjctSeCd && ["10", ognzType].includes(item.bgtSbjctOgnzSeCd)) {
                 codeArr.push({
                    code: item.kwanCd,
                    name: item.kwanNm,
                });
            }
        });
        return codeArr;
    },
    // 운영비 항 코드
    getBgt2CodeArray: (kwanCd: string, ognzCd: string) => {
        const codeArr: any[] = [];
        const ognzType: string = ognzCd.slice(-3) === "000" ? "01" : "02";
        AppContext.bgtSbjctList.forEach((item: any) => {
            if (item.sbjctLvCd === "02" && item.kwanCd === kwanCd && ["10", ognzType].includes(item.bgtSbjctOgnzSeCd)) {
                codeArr.push({
                    code: item.hangCd,
                    name: item.hangNm,
                });
            }
        });
        return codeArr;
    },
    // 운영비 목 코드
    getBgt3CodeArray: (hangCd: string, ognzCd: string) => {
        const codeArr: any[] = [];
        const ognzType: string = ognzCd.slice(-3) === "000" ? "01" : "02";
        AppContext.bgtSbjctList.forEach((item: any) => {
            if (item.sbjctLvCd === "03" && item.hangCd === hangCd && ["10", ognzType].includes(item.bgtSbjctOgnzSeCd)) {
                codeArr.push({
                    code: item.mokCd,
                    name: item.mokNm,
                });
            }
        });
        return codeArr;
    },

    /**
     * 특별회계기금 관 코드
     * @param acntgSeCd     시스템코드(C1 ~ C5)
     * @param sbjctLvCd     관(01), 항(02), 목(03)
     * @param sbjctSeCd     수입(01),지출(02)
     * @returns
     */
    getSpcBgt1CodeArray: (acntgSeCd: string, sbjctSeCd: string) => {
        const codeArr: any[] = [];
        AppContext.spcBgtSbjctList.forEach((item: any) => {
            if (item.acntgSeCd === acntgSeCd && item.sbjctLvCd === "01" && item.sbjctSeCd === sbjctSeCd) {
                 codeArr.push({
                    code: item.kwanCd,
                    name: item.kwanNm,
                });
            }
        });
        return codeArr;
    },

    // 특별회계기금 항 코드
    // acntgSeCd: 시스템코드(C1~C5) | sbjctLvCd: 관(01)/항(02)/목(03) | kwanCd: 관 코드 - sbjctSeCd: 수입(01)/지출(02)로 확인
    getSpcBgt2CodeArray: (acntgSeCd: string, kwanCd: string) => {
        const codeArr: any[] = [];
        AppContext.spcBgtSbjctList.forEach((item: any) => {
            if (item.acntgSeCd === acntgSeCd && item.sbjctLvCd === "02" && item.kwanCd === kwanCd) {
                 codeArr.push({
                    code: item.hangCd,
                    name: item.hangNm,
                });
            }
        });
        return codeArr;
    },

    // 특별회계기금 목 코드
    // acntgSeCd: 시스템코드(C1~C5) | sbjctLvCd: 관(01)/항(02)/목(03) | hangCd: 항 코드 - sbjctSeCd: 수입(01)/지출(02) 항 코드로 확인
    getSpcBgt3CodeArray: (acntgSeCd: string, hangCd: string) => {
        const codeArr: any[] = [];
        AppContext.spcBgtSbjctList.forEach((item: any) => {
            if (item.acntgSeCd === acntgSeCd && item.sbjctLvCd === "03" && item.hangCd === hangCd) {
                 codeArr.push({
                    code: item.mokCd,
                    name: item.mokNm,
                });
            }
        });
        return codeArr;
    },

    // 총괄 교부금 조직 코드
    getOvrlOgnzList: () => {
        const codeArr: any[] = [];
        AppContext.ovrlOgnzList.forEach((item: any) => {
            codeArr.push({
                code: item.code,
                name: item.name,
            });
        });
        return codeArr;
    },

    // 회계연도 공통코드
    getAcntgYearArray: () => {
        const codeArr: any[] = [];
        AppContext.acntgYearList.forEach((item: any) => {
            codeArr.push(item);
        });
        return codeArr;
    },

    // 현재 회계연도 확인: 공통코드
    getNowAcntgYear: () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;

        // 회계연도는 3월부터 시작하므로, 1~2월은 전년도 회계연도
        return month >= 3 ? year.toString() : (year - 1).toString();
    },

    // 입력한 날짜의 회계연도 확인: 공통코드
    getAcntgYear: (inDate: string) => {
        if (Util.isEmpty(inDate) || inDate.length !== 8) {
            return "";
        }
        const year  = Number(inDate.substring(0, 4));
        const month = Number(inDate.substring(4, 6));

        // 회계연도는 3월부터 시작하므로, 1~2월은 전년도 회계연도
        return month >= 3 ? year.toString() : (year - 1).toString();
    },

    /**
     * YYYYMM → YYYY-MM 변환
     * - 값이 없거나 형식이 다르면 그대로 반환 (또는 빈값)
     */
    cvtMonthStrForm: (val: string, separator: string = "-") => {
        if (Util.isEmpty(val)) {
            return "";
        }

        const value = String(val).replace(/[^0-9]/g, "");

        if (value.length !== 6) {
            return value;
        }

        return value.substring(0, 4) + separator + value.substring(4, 6);
    },
    
    // 상위 조직 코드(1차 조직: 본부)
    getUpOrgCodeArray: (grpupCode: string) => {
        const codeArr: any[] = [];
        AppContext.ognzList.forEach((item: any) => {
            if (item.grpupCode === grpupCode) {
                codeArr.push(item);
            }
        });
        return codeArr;
    },
    // 하위 조직 코드(2차 조직: 지부)
    getDownOrgCodeArray: (upOgnzCd: string) => {
        const codeArr: any[] = [];
        AppContext.ognzList.forEach((item: any) => {
            if (item.grpupCode === "02" && item.upOgnzCd === upOgnzCd) {
                codeArr.push(item);
            }
        });
        return codeArr;
    },
    /**
     * 상위 조직명 조회 (본부)
     */
    getUpOrgName: (upOgnzCd: string) => {
        let retVal = "";

        for (const orgInfo of AppContext.ognzList as any[]) {
            if (orgInfo["code"] === upOgnzCd) {
                retVal = orgInfo["name"];
                break;
            }
        }

        return retVal;
    },

    /**
     * 하위 조직명 조회 (지부)
     */
    getDownOrgName: (ogdpOrgCd: string) => {
        let retVal = "";

        for (const orgInfo of AppContext.ognzList as any[]) {
            if (orgInfo["code"] === ogdpOrgCd) {
                retVal = orgInfo["name"];
                break;
            }
        }

        return retVal;
    },
    filterData: (dataArr: any, trgtFlds: fldInfsProps[], query?: string) => {
        if (!query) {
            return dataArr;
        }
        const retDataArr: any[] = [];
        for (const item of dataArr) { // 전체 데이터 탐색
            for (const trgtFld of trgtFlds) { // 모든 키 탐색
                if (!trgtFld.fldNm) {
                    continue;
                }
                let trgtVal = "";
                if (trgtFld.type === "text") {
                    trgtVal = Util.convertNumToString(item[trgtFld.fldNm]);
                } else if (trgtFld.type === "phone") {
                    trgtVal = Util.cvtPhoneStrForm(item[trgtFld.fldNm], "-");
                } else if (trgtFld.type === "comma") {
                    trgtVal = Util.comma(item[trgtFld.fldNm]);
                } else if (trgtFld.type === "code" || trgtFld.type === "el") {
                    trgtVal = Util.getValToCode(trgtFld.catCode || "", item[trgtFld.fldNm]);
                } else {
                    continue; // text, code가 아니면 skip
                }
                // 영문일 경우 소문자로 일관화
                trgtVal = trgtVal.toLowerCase();
                query = query.toLowerCase();

                if (trgtVal.includes(query)) {
                    retDataArr.push(item);
                    break; // 이미 포함된 행이므로 남은 필드는 계산 불필요
                }
            }
        }
        return retDataArr;
    },
    // 특정 필드의 데이터 Filtering
    filterFieldData: (dataArr: any, trgtFlds: fldInfsProps[], fieldName: string, query?: string) => {
        if (!query) {
            return dataArr;
        }
        const retDataArr: any[] = [];
        for (const item of dataArr) { // 전체 데이터 탐색
            for (const trgtFld of trgtFlds) { // 모든 키 탐색
                if (!trgtFld.fldNm) {
                    continue;
                }
                let trgtVal = "";
                if (trgtFld.type === "text") {
                    if (fieldName === trgtFld.fldNm) {
                        trgtVal = Util.convertNumToString(item[trgtFld.fldNm]);
                    }
                } else {
                    continue; // text, code가 아니면 skip
                }
                // 영문일 경우 소문자로 일관화
                trgtVal = trgtVal.toLowerCase();
                query = query.toLowerCase();

                if (trgtVal.includes(query)) {
                    retDataArr.push(item);
                    break; // 이미 포함된 행이므로 남은 필드는 계산 불필요
                }
            }
        }
        return retDataArr;
    },
    // 특정 필드 2개 데이터 Filtering(and 조건)
    filterTwoFieldData: (dataArr: any, trgtFlds: fldInfsProps[], fieldName1: string, query1?: string, fieldName2?: string, query2?: string) => {
        if (!query1 && !query2) {
            return dataArr;
        }
        const retDataArr: any[] = [];
        for (const item of dataArr) { // 전체 데이터 탐색

            let trgtVal1 = "";
            let trgtVal2 = "";

            for (const trgtFld of trgtFlds) { // 모든 키 탐색
                if (!trgtFld.fldNm) {
                    continue;
                }
                if (trgtFld.type === "text") {
                    if (fieldName1 === trgtFld.fldNm) {
                        trgtVal1 = Util.convertNumToString(item[trgtFld.fldNm]);
                    }
                    if (fieldName2 === trgtFld.fldNm) {
                        trgtVal2 = Util.convertNumToString(item[trgtFld.fldNm]);
                    }
                } else {
                    continue;
                }
            }
            trgtVal1 = trgtVal1.toLowerCase();
            trgtVal2 = trgtVal2.toLowerCase();
            query1 = (query1 ?? "").toLowerCase();
            query2 = (query2 ?? "").toLowerCase();

            if ((!query1 || trgtVal1.includes(query1)) && (!query2 || trgtVal2.includes(query2))) {
                retDataArr.push(item);
            }
        }
        return retDataArr;
    },
    // 특정 필드 2개 데이터 Filtering(or 조건)
    filterTwoOrFieldData: (dataArr: any, trgtFlds: fldInfsProps[], fieldName1: string, query1?: string, fieldName2?: string, query2?: string) => {
        if (!query1 && !query2) {
            return dataArr;
        }
        const retDataArr: any[] = [];
        for (const item of dataArr) { // 전체 데이터 탐색

            let trgtVal1 = "";
            let trgtVal2 = "";

            for (const trgtFld of trgtFlds) { // 모든 키 탐색
                if (!trgtFld.fldNm) {
                    continue;
                }
                if (trgtFld.type === "text") {
                    if (fieldName1 === trgtFld.fldNm) {
                        trgtVal1 = Util.convertNumToString(item[trgtFld.fldNm]);
                    }
                    if (fieldName2 === trgtFld.fldNm) {
                        trgtVal2 = Util.convertNumToString(item[trgtFld.fldNm]);
                    }
                } else {
                    continue;
                }
            }
            trgtVal1 = trgtVal1.toLowerCase();
            trgtVal2 = trgtVal2.toLowerCase();
            query1 = (query1 ?? "").toLowerCase();
            query2 = (query2 ?? "").toLowerCase();

            if ((!query1 || trgtVal1.includes(query1)) || (!query2 || trgtVal2.includes(query2))) {
                retDataArr.push(item);
            }
        }
        return retDataArr;
    },
    filterGridData: (dataArr: any, trgtFlds: fldInfsProps[], queryList?: Record<string, any>) => {
        if (!queryList || Object.entries(queryList).length === 0) {
            return dataArr;
        }

        return Object.entries(queryList).reduce((array: any, [key, val]) => {
            if (Util.isEmpty(val)) {
                return array;
            }
            // date 구분
            const tempKey = key.split('|');
            if (tempKey.length > 1) {
                if (tempKey[1] === 'startDt') {
                    array = array.filter((item: any) => dayjs(val).isBefore(Util.convertNumToString(item[tempKey[0]])));
                } else if (tempKey[1] === 'endDt') {
                    array = array.filter((item: any) => dayjs(val).isAfter(Util.convertNumToString(item[tempKey[0]])));
                }

                return array;
            }

            const trgtFld = trgtFlds.filter(item => item.fldNm === key)[0];
            switch (trgtFld.type) {
                case "text":
                case "code":
                case "el":
                    array = array.filter((item: any) => Util.convertNumToString(item[key]).includes(val));
                    return array;
                case "phone":
                    array = array.filter((item: any) => Util.cvtPhoneStrForm(item[key], '-').includes(val));
                    return array;
                case "comma":
                    array = array.filter((item: any) => Util.comma(item[key]).includes(val));
                    return array;
                default:
                    return array;
            }
        }, dataArr);
    },

    // 비밀번호 패턴 체크
    chkPasswdPtn: (inputString: string) => {
        // 8자이상 20자이하로 영문, 숫자, 특수문자를 1자이상 반드시 포함
        const chkReg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#.~_-])[A-Za-z\d@$!%*?&#.~_-]{8,20}$/;
        const chkPasswd = chkReg.test(inputString);
        return chkPasswd;
    },

    // 사업자등록번호 입력 변환
    setBizRegNum: (inputValue?: string) => {
        if (Util.isEmpty(inputValue) || inputValue === undefined) {
            return "";
        }
        inputValue = inputValue.replace(/-/g, "");;
        if (isNaN(Number((inputValue)))) {
            return inputValue.slice(0, -1);
        }
        return inputValue.replace(/-/g, '').replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
    },

    // 사업자등록번호 표시 처리
    cvtBizRegNumForm: (BizNumStr: string, separetor: string) => {
        if (Util.isEmpty(BizNumStr)) {
            return "";
        } else {
            return BizNumStr.substring(0, 3) + separetor + BizNumStr.substring(3, 5) + separetor + BizNumStr.substring(5, 10);
        }
    },

    // 문자열에서 하이픈() 제거
    unHypen: (inputValue:string): string => {
        let sResult = "";
        sResult = inputValue.replace(/[-]/gi, "");
        return sResult;
    },

    // 이메일 패턴 체크
    chkEmailPtn: (inputValue: string): boolean => {
        // 영문,숫자 + 특수문자(-_.) + 영문, 숫자 + @ + 영문,숫자 + 특수문자(-_.) + . + 영문 2~3자
        const chkReg = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
        const chkEmail = chkReg.test(inputValue);
        return chkEmail;
    },

    // 핸드폰 패턴 체크
    chkPhonePtn: (inputValue:string): boolean => {
        const chkReg =/^(010)[0-9]{3,4}[0-9]{4}$/;
        const chkPhone = chkReg.test(inputValue);
        return chkPhone;
    },

    // 문자에 공백 포함 유무 확인
    isBlank: (inputValue:string): boolean => {
        const blankPattern = /[\s]/g;   // 공백 확인
        const isBlank = blankPattern.test(inputValue);
        return isBlank;
    },

    // 문자의 왼쪽 공백 삭제
    lTrim: (inputValue:string): string => {
        const newVal = inputValue.replace(/^\s*/, "");
        return newVal;
    },

    // 문자의 오른쪽 공백 제거
    rTrim: (inputValue:string): string => {
        const newVal = inputValue.replace(/\s*$/, "");
        return newVal;
    },

    // 모든 공백 제거
    aTrim: (inputValue:string): string => {
        const newVal = inputValue.replace(/(\s*)/g, "");
        return newVal;
    },

    // 숫자, 마침표만 허용
    checkNumber: (value: string): string => {
        const pattern = /[^\d.]/g;
        return pattern.test(value) ? value.replace(pattern, '') : value;
    },

    toDataURL: (url: string, callback: Function) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function() {
            const reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    },
    getFileSrc: (fileUrl: string) => {
        return new URL(`/assets/${fileUrl}`, window.location.origin).href;
    },
    getImgSrc: (imageUrl: string) => {
        return Util.getFileSrc(`img/${imageUrl}`);
    },
    sortListJson: (dataArr: any[], order: "asc" | "desc", orderBy: string) => {
        const currItems = Util.stableSort(
            dataArr,
            Util.getComparator(order, orderBy)
        )
        return currItems;
    },
    getComparator<Key extends keyof any>(order: Order, orderBy: Key): (a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number {
        return order === 'desc'
            ? (a, b) => Util.descendingComparator(a, b, orderBy)
            : (a, b) => -Util.descendingComparator(a, b, orderBy);
    },
    descendingComparator: <T>(a: T, b: T, orderBy: keyof T) => {
        if (Util.nvl(b[orderBy], "") < Util.nvl(a[orderBy], "")) {
            return -1;
        }
        if (Util.nvl(b[orderBy], "") > Util.nvl(a[orderBy], "")) {
            return 1;
        }
        return 0;
    },
    stableSort: <T>(array: readonly T[], comparator: (a: T, b: T) => number) => {
        const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    },
    utoa: (str: string) => {
        return window.btoa(unescape(encodeURIComponent(str)));
    },
    atou: (str: string) => {
        return decodeURIComponent(escape(window.atob(str)));
    },
    moveValue: (array: number[], fromIndex: number, toIndex: number) => {
        const item = array.splice(fromIndex, 1)[0];
        return array.splice(toIndex, 0, item);
    },
    // [기능] camelCase 변환
    toCamelCase: (str: string) => {
        if (Util.isEmpty(str)) return "";

        return str
            .toLowerCase()
            .split('_')
            .map((word, index) =>
                index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join('');
    },
    // [기능] snakeCase 변환
    toSnakeCase: (str: string, type: 'lower' | 'upper'= 'lower') => {
        if (Util.isEmpty(str)) return "";
        // str = str.replace(/([a-z])([A-Z])/g, '$1_$2');
        str = str.replace(/([a-z0-9])([A-Z])/g, '$1_$2');
        if (type === 'lower') {
            return str.toLowerCase();
        } else {
            return str.toUpperCase();
        }
    },
    rgbValidate: (val: string) => {
        let rgb = String(val);
        if (rgb.startsWith("#")) {
            rgb = rgb.slice(1);
        }
        if (rgb.length !== 6) {
            throw "16진수로 표현된 RGB의 값이 올바르지 않습니다.";
        }
        return rgb;
    },
    hexToRgb: (hex: string) => {
        const rgb = Util.rgbValidate(hex).match(/.{1,2}/g);
        if (rgb === null) {
            return;
        }
        const result = [
            parseInt(rgb[0], 16),
            parseInt(rgb[1], 16),
            parseInt(rgb[2], 16)
        ];
        return result;
    },
    setHexOpacity: (hex: string, opacity: number) => {
        const Alpha = Math.round(opacity * 255).toString(16).padStart(2, '0');
        return hex + Alpha
    },
    getChromeVersion: () => {
        const match = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        return match ? parseInt(match[2], 10) : 0;
    },
};
export default Util;